import Link from "@amzn/meridian/esm/components/link";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import { openUrl } from "../../utils/zoomSdkUtils";
import { THEME_COLOR } from "../../styles/colors";

const RTS_POLICY_URL = "https://policy.a2z.com/docs/693659/publication";

/**
 * Disclaimer footer shared by the classic and agentic chat inputs: the
 * "AI may make mistakes" note plus the RTS policy link.
 */
const ChatDisclaimerFooter = () => (
  <Row alignmentHorizontal="center" spacingInset="100 none none none">
    <Theme tokens={{ textB100FontSize: "11px",
      linkForegroundColorDefault: THEME_COLOR.MID_GRAY,
      linkForegroundColorHover: THEME_COLOR.MID_GRAY,
      linkForegroundColorPressed: THEME_COLOR.MID_GRAY}}>
      <Text type="b100" color="secondary">
        AI may make mistakes. Always check for accuracy.{" "}
        <Link type="primary" href={RTS_POLICY_URL} onClick={(href) => openUrl(href, "Failed to open RTS policy URL:")}>
          RTS policy
        </Link>
      </Text>
    </Theme>
  </Row>
);

export default ChatDisclaimerFooter;
